/* import __COLOCATED_TEMPLATE__ from './cvda-list-filter.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import { type CvdaListItem } from '../search2';
import { type Comparison } from 'embercom/objects/inbox/search/predicate-group';
import type { ComparisonOption } from 'embercom/components/inbox2/search/more-filters-item';

interface Signature {
  Element: HTMLElement;
  Args: {
    onSelect: (value: CvdaListItem) => void;
    listItems: CvdaListItem[];
    selected?: CvdaListItem;
    comparisonOptions?: ComparisonOption[] | null;
    comparisonSelected?: Comparison;
    onComparisonSelect?: (comparison: Comparison) => void;
  };
}

export default class CvdaListFilter extends Component<Signature> {
  @service declare intl: IntlService;

  get selectedRadioButtonValue(): Comparison {
    return this.args.comparisonSelected || this.defaultComparison;
  }

  set selectedRadioButtonValue(value: Comparison) {
    // This setter is needed for RadioGroup binding, but we handle the change via onChange
    if (this.args.onComparisonSelect) {
      this.args.onComparisonSelect(value);
    }
  }

  get defaultComparison(): Comparison {
    // If we have comparison options, use the first one, otherwise default to 'eq'
    if (this.args.comparisonOptions && this.args.comparisonOptions.length > 0) {
      return this.args.comparisonOptions[0].value as Comparison;
    }
    return 'eq';
  }

  get radioButtons() {
    if (this.args.comparisonOptions && this.args.comparisonOptions.length > 0) {
      return this.args.comparisonOptions.map((option) => ({
        value: option.value,
        label: option.label,
      }));
    }

    return [
      {
        value: 'eq',
        label: this.intl.t('inbox.search.filters.more-filters.is'),
      },
    ];
  }

  get groupList() {
    return [
      {
        items: this.args.listItems,
      },
    ];
  }

  get selectedLabel() {
    return this.args.selected?.text || '';
  }

  @action onSelectItem(item: CvdaListItem) {
    this.args.onSelect(item);
  }

  @action onComparisonChange(value: string) {
    if (this.args.onComparisonSelect) {
      this.args.onComparisonSelect(value as Comparison);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::CvdaListFilter': typeof CvdaListFilter;
  }
}
